import { createSlice } from "@reduxjs/toolkit";
import { City, Street } from "models/Constants";

interface ConstantsSliceState {
  cities: City[];
  streets: Street[];
  timestamp: Date | null;
}

const initialState: ConstantsSliceState = {
  cities: [],
  streets: [],
  timestamp: null,
};

const constantsSlice = createSlice({
  name: "constantsData",
  initialState,
  reducers: {
    updateCities(state, action) {
      if (action.payload?.cityList) {
        state.cities = action.payload.cityList;
      } else {
        state.cities = action.payload;
      }
    },
    updateStreets(state, action) {
      if (action.payload?.streetList) {
        state.streets = action.payload.streetList;
      } else {
        state.streets = action.payload;
      }
    },
  },
});

export const { updateCities } = constantsSlice.actions; // Export the updateCities action
export default constantsSlice.reducer;
